import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-validacion-referencia',
  templateUrl: './validacion-referencia.component.html',
  styleUrls: ['./validacion-referencia.component.scss'],
})
export class ValidacionReferenciaComponent implements OnInit {
  form: FormGroup;

  tipo_validaciones = ['Cheque de Gerencia', 'Transferencia Interbancaria'];
  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      descripcion: [values ? values.descripcion : '', [Validators.required]],
      enviada: [values ? values.enviada : '', [Validators.required]],
      fecha: [values ? values.fecha : '', [Validators.required]],
    });
  }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
